'use client'

import React from 'react'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Tariff: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
					Тарифы
					</Typography>
					<Typography variant='h2' className={styles.title}>
					Прозрачная стоимость лицензий
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<Table />
			</AnimatedSection>
		</section>
	)
}

const tableData = {
	columns: ['', 'Ежемесячная оплата', 'Годовая оплата'],

	rows: [
		{
			cells: [
				'Рабочие места',
				'1 рабочее место',
				'1 рабочее место'
			]
		},
		{
			cells: [
				'Поддержка устройств',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg'
			]
		},
		{
			cells: [
				'Техническое сопровождение',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg'
			]
		},
		{
			cells: [
				'Стоимость',
				'<span class="price">1 190</span><span class="priceCurrency">₽/мес.</span>',
				'<span class="price">11 500</span><span class="priceCurrency">₽/год</span>'
			]
		},
		{
			cells: [' ',
				'btn',
				'btn'
			]
		}
	]
}

const Table: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
					<thead>
						<tr>
							{tableData.columns.map((col, i) => (
							<th key={i}>
								<Typography variant="p1" color="accent">
								{col}
								</Typography>
							</th>
							))}
						</tr>
					</thead>
				<tbody>
					{tableData.rows.map((row, rowIndex) => (
						<tr key={rowIndex}>
							{row.cells.map((cell, colIndex) => (
								<td key={colIndex}>
									{cell === 'btn' ? (
										<button
											className={styles.btn}
											onClick={openConsultationModal}
										>
											<span className={styles.btnText}>Оставить заявку</span>
										</button>
									) : typeof cell === 'string' && cell.endsWith('.svg') ? (
										<img src={cell} alt="" className={styles.cellIcon} />
									  ) : typeof cell === 'string' ? (
										<div
										  className={styles.cellHtml}
										  dangerouslySetInnerHTML={{ __html: cell }}
										/>
									  ) : (
										cell
									  )}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}

Tariff.displayName = 'Tariff'

export default Tariff
